import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10">
            <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

            <p className="mb-4">Effective Date: June 8, 2025</p>

            <p className="mb-4">
                This Privacy Policy explains how we collect, use, and protect your information when you visit our website, <a href="https://www.dysband.com" className="text-blue-600 underline">https://www.dysband.com</a>.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">1. Information We Collect</h2>
            <p className="mb-4">
                We may collect the following information:
                <ul className="list-disc list-inside ml-4">
                    <li>Personal Information you provide via forms (e.g. name, email address)</li>
                    <li>Usage Data collected automatically through cookies or third-party analytics tools (e.g. IP address, browser type, pages visited)</li>
                </ul>
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">2. How We Use Your Information</h2>
            <p className="mb-4">
                We use your information to:
                <ul className="list-disc list-inside ml-4">
                    <li>Respond to inquiries submitted through our contact form</li>
                    <li>Improve the performance and content of our website</li>
                    <li>Monitor site traffic and usage patterns</li>
                </ul>
                We do not sell, trade, or rent your personal information to others.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">3. Cookies & Analytics</h2>
            <p className="mb-4">
                We may use cookies and third-party tools like Google Analytics to understand how users interact with the site. You can disable cookies through your browser settings.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">4. Data Sharing</h2>
            <p className="mb-4">
                We may share your data only:
                <ul className="list-disc list-inside ml-4">
                    <li>With service providers who help us operate the site</li>
                    <li>When required by law</li>
                </ul>
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">5. Your Rights</h2>
            <p className="mb-4">
                You may:
                <ul className="list-disc list-inside ml-4">
                    <li>Request a copy of the personal data we hold about you</li>
                    <li>Ask us to delete your information</li>
                </ul>
                To make a request, contact us at: <a href="mailto:contact@dysband.com" className="text-blue-600 underline">contact@dysband.com</a>
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">6. Links to Other Sites</h2>
            <p className="mb-4">
                Our website may contain links to other websites. We are not responsible for the privacy practices of those sites.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">7. Changes to This Policy</h2>
            <p className="mb-4">
                We may update this policy from time to time. Changes will be posted on this page with an updated effective date.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-2">8. Contact Us</h2>
            <p className="mb-4">
                If you have any questions about this Privacy Policy, contact us at:<br />
                📧 <a href="mailto:contact@dysband.com" className="text-blue-600 underline">contact@dysband.com</a>
            </p>
        </div>
    );
};

export default PrivacyPolicy;
